export default "__VITE_ASSET__DPy85sTy__"